module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "min-width": "1200px",
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    staticStyle: {
      "min-width": "600px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('div', {
    staticClass: "mainSelect"
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入/选择小程序名称"
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  }, _vm._l((_vm.IssAppList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id,
        "default-first-option": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.changeProduct(item)
        }
      }
    })
  }), 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf9bb224"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/issue/channelData.vue
// module id = 1151
// module chunks = 2